export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHANGE_LANG = "CHANGE_LANG";
export const CHANGE_COUNTRY = "CHANGE_COUNTRY";
export const CHANGE_OCCUPATION = "CHANGE_OCCUPATION";